import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function TermsOfService() {
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-white/20" data-id="element-679">
      <Navigation data-id="element-680" />

      <main className="pt-32 pb-24 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-681">
        <div className="mb-12" data-id="element-682">
          <h1 className="text-4xl md:text-5xl font-medium mb-4 tracking-tight" data-id="element-683">
            Terms of Service
          </h1>
          <p className="text-zinc-400" data-id="element-684">
            Last Updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
        </div>

        <div className="space-y-10 text-zinc-300 leading-relaxed" data-id="element-685">
          <section data-id="element-686">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-687">
              1. Acceptance of Terms
            </h2>
            <p data-id="element-688">
              By accessing or using the website and services provided by VCA
              Capital Advisors (DBA of Vantage Capital Group, LLC) ("we," "our,"
              or "us"), you agree to be bound by these Terms of Service. If you
              do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section data-id="element-689">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-690">
              2. Description of Services
            </h2>
            <p data-id="element-691">
              VCA Capital Advisors acts as a business funding brokerage and
              advisory service. We assist businesses in identifying, applying
              for, and securing commercial financing from third-party lenders
              and funding partners. We are not a direct lender, bank, or
              depository institution. Any funding offers, terms, and approvals
              are determined solely by the third-party funding providers.
            </p>
          </section>

          <section className="bg-zinc-900/50 p-6 rounded-xl border border-zinc-800" data-id="element-692">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-693">
              3. SMS/Text Messaging Terms
            </h2>
            <p className="mb-3" data-id="element-694">
              By providing your phone number to VCA Capital Advisors, you agree
              to the following terms regarding SMS/Text messaging:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-695">
              <li data-id="element-696">
                <strong data-id="element-697">Consent:</strong> You expressly consent to receive SMS
                messages from VCA Capital Advisors regarding your funding
                inquiry, application status, and account updates.
              </li>
              <li data-id="element-698">
                <strong data-id="element-699">Frequency:</strong> Message frequency varies based on
                your interaction with us and the status of your application.
              </li>
              <li data-id="element-700">
                <strong data-id="element-701">Rates:</strong> Standard message and data rates may
                apply depending on your mobile carrier plan.
              </li>
              <li data-id="element-702">
                <strong data-id="element-703">Opt-Out:</strong> You may opt out of receiving SMS
                messages at any time by texting <strong data-id="element-704">STOP</strong>. After
                texting STOP, you will receive one final message confirming your
                opt-out.
              </li>
              <li data-id="element-705">
                <strong data-id="element-706">Assistance:</strong> For help or more information, text{' '}
                <strong data-id="element-707">HELP</strong> or contact us at the phone number provided
                below.
              </li>
              <li data-id="element-708">
                <strong data-id="element-709">Carrier Liability:</strong> Mobile carriers are not
                liable for delayed or undelivered messages.
              </li>
              <li data-id="element-710">
                <strong data-id="element-711">Not a Condition:</strong> SMS consent is not required to
                use our services or receive funding. You may choose to
                communicate with us solely via email or phone calls.
              </li>
            </ul>
          </section>

          <section data-id="element-712">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-713">
              4. User Responsibilities
            </h2>
            <p className="mb-3" data-id="element-714">When using our services, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-715">
              <li data-id="element-716">
                Provide accurate, current, and complete information about your
                business and financial status.
              </li>
              <li data-id="element-717">Maintain the confidentiality of any account credentials.</li>
              <li data-id="element-718">Use our services only for lawful business purposes.</li>
              <li data-id="element-719">
                Not submit fraudulent applications or misrepresent your identity
                or business details.
              </li>
            </ul>
          </section>

          <section data-id="element-720">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-721">
              5. Disclaimer of Warranties
            </h2>
            <p data-id="element-722">
              Our services are provided on an "as is" and "as available" basis.
              VCA Capital Advisors makes no warranties, expressed or implied,
              regarding the availability of funding, specific rates, terms, or
              the approval of any application. We do not guarantee that you will
              receive funding or that the terms offered by third-party lenders
              will meet your expectations.
            </p>
          </section>

          <section data-id="element-723">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-724">
              6. Limitation of Liability
            </h2>
            <p data-id="element-725">
              To the maximum extent permitted by law, VCA Capital Advisors and
              its affiliates, officers, employees, and agents shall not be
              liable for any indirect, incidental, special, consequential, or
              punitive damages, or any loss of profits or revenues, whether
              incurred directly or indirectly, or any loss of data, use,
              goodwill, or other intangible losses resulting from your use of
              our services or any interactions with third-party lenders.
            </p>
          </section>

          <section data-id="element-726">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-727">
              7. Indemnification
            </h2>
            <p data-id="element-728">
              You agree to indemnify and hold harmless VCA Capital Advisors, its
              affiliates, and their respective officers, directors, employees,
              and agents from any claims, damages, liabilities, costs, or
              expenses (including reasonable attorneys' fees) arising out of
              your use of our services, your violation of these Terms, or your
              violation of any rights of a third party.
            </p>
          </section>

          <section data-id="element-729">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-730">
              8. Governing Law
            </h2>
            <p data-id="element-731">
              These Terms of Service and your use of our website shall be
              governed by and construed in accordance with the laws of the State
              of Florida, without regard to its conflict of law principles. Any
              legal action or proceeding arising under these Terms shall be
              brought exclusively in the federal or state courts located in
              Miami, Florida.
            </p>
          </section>

          <section data-id="element-732">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-733">
              9. Changes to Terms
            </h2>
            <p data-id="element-734">
              We reserve the right to modify or replace these Terms of Service
              at any time. Any changes will be effective immediately upon
              posting on this page. Your continued use of our services after any
              such changes constitutes your acceptance of the new Terms.
            </p>
          </section>

          <section data-id="element-735">
            <h2 className="text-2xl font-medium text-white mb-4" data-id="element-736">
              10. Contact Information
            </h2>
            <p className="mb-4" data-id="element-737">
              If you have any questions about these Terms of Service, please
              contact us at:
            </p>
            <div className="bg-zinc-900/30 p-6 rounded-xl border border-zinc-800" data-id="element-738">
              <p className="font-medium text-white mb-1" data-id="element-739">
                VCA Capital Advisors
              </p>
              <p className="text-sm text-zinc-400 mb-4" data-id="element-740">
                DBA of Vantage Capital Group, LLC
              </p>
              <p data-id="element-741">1221 Brickell Ave STE 900</p>
              <p data-id="element-742">Miami, FL 33131</p>
              <p className="mt-2" data-id="element-743">
                Email:{' '}
                <a href="mailto:info@vcacapitaladvisors.com" className="text-white hover:underline" data-id="element-744">
                  info@vcacapitaladvisors.com
                </a>
              </p>
              <p data-id="element-745">
                Phone:{' '}
                <a href="tel:929-816-6805" className="text-white hover:underline" data-id="element-746">
                  (929) 816-6805
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer data-id="element-747" />
    </div>;
}